enum AuditItemType {
  // Campaign
  Campaign = 'Campaign',
  CampaignProperty = 'CampaignProperty',

  // Line Item
  LineItem = 'LineItem',
  LineItemCreative = 'LineItemCreative',
  LineItemDemographicTarget = 'LineItemDemographicTarget',
  LineItemProperty = 'LineItemProperty',
  LineItemTargetingCriterion = 'LineItemTargetingCriterion',
  LineItemTargetingCriterionValue = 'LineItemTargetingCriterionValue',
  LineItemMediaOwnerApproval = 'LineItemMediaOwnerApproval',

  // Creative
  Creative = 'Creative',
  CreativeFile = 'CreativeFile',
  CreativeIab = 'CreativeIab',
  CreativeTrackingUrl = 'CreativeTrackingUrl',
  CreativeMediaOwnerApproval = 'CreativeMediaOwnerApproval',
  CreativeLanguage = 'CreativeLanguage',
  CreativeProperty = 'CreativeProperty',

  // Unit
  Unit = 'Unit',
  UnitGeofence = 'UnitGeofence',
  UnitFallbackCreative = 'UnitFallbackCreative',
  UnitIabBlacklist = 'UnitIabBlacklist',
  UnitAdvertiserBlacklist = 'UnitAdvertiserBlacklist',
  UnitLanguage = 'UnitLanguage',
  UnitProperty = 'UnitProperty',
  UnitMarket = 'UnitMarket',

  // Site
  Site = 'Site',
  SiteMarket = 'SiteMarket',
  GeofenceGroupSite = 'GeofenceGroupSite',

  // Mobile Line Item
  MobileLineItemCreative = 'MobileLineItemCreative',
  MobileLineItem = 'MobileLineItem',
  MobileLineItemLineItem = 'MobileLineItemLineItem',

  // Network
  Network = 'Network',

  // Report Definition
  ReportDefinition = 'ReportDefinition',

  // Package
  Package = 'Package',

  // Inventory targeting
  UnitTargeting = 'UnitTargeting',
  UnitExclusion = 'UnitExclusion',
  SiteTargeting = 'SiteTargeting',
  SiteExclusion = 'SiteExclusion',
  MediaOwnerTargeting = 'MediaOwnerTargeting',
  LocationTargeting = 'LocationTargeting',
  LocationExclusion = 'LocationExclusion',
  NetworkTargeting = 'NetworkTargeting',
  NetworkExclusion = 'NetworkExclusion',
  MediatypeTargeting = 'MediatypeTargeting',
  MediatypeExclusion = 'MediatypeExclusion',
  MarketTargeting = 'MarketTargeting',
  MarketExclusion = 'MarketExclusion',
  GeofenceGroupTargeting = 'GeofenceGroupTargeting',
  GeofenceGroupExclusion = 'GeofenceGroupExclusion',
  UnitTagTargeting = 'UnitTagTargeting',
  UnitTagExclusion = 'UnitTagExclusion',
  LanguageTargeting = 'LanguageTargeting',
  LanguageExclusion = 'LanguageExclusion',
  UnitPackTargeting = 'UnitPackTargeting',
  UnitPackExclusion = 'UnitPackExclusion',
  CreativeFormatTargeting = 'CreativeFormatTargeting',
  CreativeFormatExclusion = 'CreativeFormatExclusion',
  CreativeOrientationTargeting = 'CreativeOrientationTargeting',
  CreativeOrientationExclusion = 'CreativeOrientationExclusion',
  IabCategoryTargeting = 'IabCategoryTargeting',
  IabCategoryExclusion = 'IabCategoryExclusion',
  CO2eEmissionsScoreTargeting = 'CO2eEmissionsScoreTargeting',
}

export default AuditItemType;
